import CancellableHelper from "../CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { BookingReportItemResponse } from "@/models/api/report/BookingReportItem";
import { BookingItemsResponse } from "@/models/api/report/BookingItem";

export const URL_GET_BOOKING_REPORT_ITEMS = "/BookingReport/GetBookingReportItems";
export const URL_POST_TOGGLE_REPORT_ITEM_STATUS = "/BookingReport/ToggleStatus/${ReportItemId}";
export const URL_POST_PAIR_BOOKING_REPORT_ITEMS_WITH_BOOKING_ITEMS =
  "/BookingReport/PairBookingReportItemsWithBookingItems";
export const URL_GET_BOOKING_ITEMS = "/BookingReport/GetBookingItems";
export const URL_POST_PAIR_BOOKING_REPORT_ITEM_WITH_BOOKING_ITEM =
  "/BookingReport/PairBookingReportItem/${ReportItemId}/WithBookingItem/${BookingItemId}";

//#region
const _getBookingReportItems = new CancellableHelper<BookingReportItemResponse>(
  URL_GET_BOOKING_REPORT_ITEMS,
  BookingReportItemResponse
);
_getBookingReportItems.jsonSerializer = true;
export const getBookingReportItems = async (
  genericTableRequest: GenericTableRequest
): Promise<BookingReportItemResponse> => {
  return await _getBookingReportItems.get(genericTableRequest);
};

const _postToggleReportItemStatus = new CancellableHelper<null>(URL_POST_TOGGLE_REPORT_ITEM_STATUS, null, true);
export const postToggleReportItemStatus = async (reportItemId: number): Promise<void> => {
  await _postToggleReportItemStatus.post({ ReportItemId: reportItemId }, null);
};

const _postPairBookingReportItemsWithBookingItems = new CancellableHelper<null>(
  URL_POST_PAIR_BOOKING_REPORT_ITEMS_WITH_BOOKING_ITEMS
);
export const postPairBookingReportItemsWithBookingItems = async (): Promise<void> => {
  await _postPairBookingReportItemsWithBookingItems.post();
};

const _getBookingItems = new CancellableHelper<BookingItemsResponse>(URL_GET_BOOKING_ITEMS, BookingItemsResponse);
_getBookingItems.jsonSerializer = true;
export const getBookingItems = async (genericTableRequest: GenericTableRequest): Promise<BookingItemsResponse> => {
  return await _getBookingItems.get(genericTableRequest);
};

const _postPairBookingReportItemWithBookingItem = new CancellableHelper<null>(
  URL_POST_PAIR_BOOKING_REPORT_ITEM_WITH_BOOKING_ITEM,
  null,
  true
);
export const postPairBookingReportItemWithBookingItem = async (
  reportItemId: number,
  bookingItemId: number
): Promise<void> => {
  await _postPairBookingReportItemWithBookingItem.post(
    { ReportItemId: reportItemId, BookingItemId: bookingItemId },
    null
  );
};
